import './style.scss'
import { useContext, useEffect, useRef, useState } from "react"
import { AbsoluteContainer, AppSpan, AppText, Circle, CustomContainer, FixedContainer, FlexRow, GridContainer, Icon, MenuIcon } from "src/style"
import VisibilityContext from 'src/provider/state-manager/visibilityProvider'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import UserContext from 'src/provider/state-manager/userProvider'
import TransferIcon from 'src/assets/svg/transfer-icon-d2'
import AirtimeIcon from 'src/assets/svg/airtime-icon-d2'
import BillsIcon from 'src/assets/svg/bills-icon-d2'
import CardlessWithdrawalIcon from 'src/assets/svg/cardless-withdrawal-icon-d2'
import {BsBellFill} from 'react-icons/bs'
import { FiMenu } from 'react-icons/fi'
import { VscChromeClose } from 'react-icons/vsc'
import { HiOutlineChevronDoubleRight } from 'react-icons/hi'
import { NotificationPopD2, QuickLinks, MakeTransferD2, Airtime_DataD2, BillTypesD2, CardlessWithdrawalD2, MyAccount, AccountUpgradeD2 } from 'src/component'
import utility from 'src/utils/utility'
import { useLocation } from 'react-router-dom'
import { Features } from 'src/model'
import AlertModal from 'src/component/AlertModal'

export const HeaderD2 = () => {
    const location = useLocation()
    const {visibility, showSideBar, setVisibilityProperty} = useContext(VisibilityContext)
    const {info: {institutionData}} = useContext(AppInfoContext)
    const {user: {userInfo: {profileInfo}, notifications, uploadedProfilePics}} = useContext(UserContext)
    const [isQuicklinks, setIsQuicklinks] = useState(false)
    const [isNotifPop, setIsNotifPop] = useState(false)
    const [isTransfer, setIsTransfer] = useState(false)
    const [isAirtime_Data, setIsAirtime_Data] = useState(false)
    const [isBillsPayment, setIsBillsPayment] = useState(false)
    const [isCardlessWithdrawal, setIsCardlessWithdrawal] = useState(false)
    const [title, setTitle] = useState('home')
    const [appLogo, setAppLogo] = useState('')
    const [view, setView] = useState('')
    const [uploadedPics, setUploadedPics] = useState(uploadedProfilePics)
    const [isAlert, setIsAlert] = useState(false)
    const [verifyAccount, setVerifyAccount] = useState(false)

    const useVerifyMe: boolean =
        institutionData?.useVerifyMeForTransactions === true &&
        profileInfo?.isFaceVerified === false;

    useEffect(() => {
        if (institutionData) setAppLogo(institutionData.logo)
    }, [institutionData?.logo])

    useEffect(() => {
        if (uploadedProfilePics) setUploadedPics(uploadedProfilePics)
    }, [uploadedProfilePics])

    useEffect(() => {
        setTitle(utility.getPageTitle());

        return () => { }
    }, [location])

    function handleNotification () {
        if (title === 'Home' && !window.matchMedia('(max-width: 1200px)').matches) {
            setVisibilityProperty('isDashboardNotif', !visibility.isDashboardNotif)
            return 
        }
        setIsNotifPop(true)
    }
 
    return (
        <>
            <MenuIcon 
                isSideBar={visibility.isSideBar} onClick={() => showSideBar(!visibility.isSideBar)}
            >
                {
                    visibility.isSideBar ? 
                        <GridContainer width='auto' sizeUnit='' bgColor='#ffffff'>
                            <VscChromeClose/>
                        </GridContainer> 
                        : <FiMenu />
                }
            </MenuIcon>

            <FixedContainer width="100" sizeUnit="%" zIndex="5" top='0' left='0'>
                <GridContainer 
                    height="9" bgColor="#ffffff" 
                    leftPadding="2.5" rightPadding='2.5' 
                    className='header-container-d2'
                >
                    <FlexRow justifyContent='space-between' gap='2'>
                        <CustomContainer width='15.4' height='4'>
                            { appLogo ? <Icon src={appLogo} className='app-logo-icon' /> : null }
                        </CustomContainer>
                        <FlexRow width='auto' sizeUnit='' className='header-action-link'>
                            { (institutionData.featureIDs?.includes(Features.INTER_BANK_TRANSFER) || institutionData.featureIDs?.includes(Features.INTRA_BANK_TRANSFER)) &&
                                <FlexRow 
                                    gap='1' width='auto' sizeUnit='' 
                                    leftPadding='2' rightPadding='2'
                                    style={{borderRight: '1px solid #CACACA'}}
                                >
                                    <TransferIcon 
                                        className='icon-component' 
                                        style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} 
                                    />
                                    <AppText 
                                        textSize='1.6' fontWeight='600' color='#25282B' 
                                        cursor='pointer' hoverColor='#0D968F' textWrap='normal'
                                        onClick={() => { useVerifyMe ? setIsAlert(true) : setIsTransfer(true)}}
                                    >
                                        Transfer
                                    </AppText>
                                </FlexRow>
                            }
                            { institutionData.featureIDs?.includes(Features.AIRTIME_TOPUP) &&
                                <FlexRow 
                                    gap='1' width='auto' sizeUnit=''
                                    leftPadding='2' rightPadding='2'
                                    style={{borderRight: '1px solid #CACACA'}}
                                >
                                    <AirtimeIcon 
                                        className='icon-component' 
                                        style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} 
                                    />
                                    <AppText 
                                        textSize='1.6' fontWeight='600' color='#25282B' 
                                        cursor='pointer' hoverColor='#0D968F' textWrap='normal'
                                        onClick={() => { useVerifyMe ? setIsAlert(true) : setIsAirtime_Data(true)}}
                                    >
                                        Airtime
                                    </AppText>
                                </FlexRow>
                            }
                            { institutionData.featureIDs?.includes(Features.BILLS_PAYMENT) &&
                                <FlexRow 
                                    gap='1' width='auto' sizeUnit=''
                                    leftPadding='2' rightPadding='2'
                                    style={{borderRight: '1px solid #CACACA'}}
                                >
                                    <BillsIcon 
                                        className='icon-component'
                                        style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}}  
                                    />
                                    <AppText 
                                        textSize='1.6' fontWeight='600' color='#25282B' 
                                        cursor='pointer' hoverColor='#0D968F' textWrap='normal'
                                        onClick={() => { useVerifyMe ? setIsAlert(true) : setIsBillsPayment(true)}}
                                    >
                                        Bills
                                    </AppText>
                                </FlexRow>
                            }
                            {/*<FlexRow */}
                            {/*    gap='1.5' width='auto' sizeUnit=''*/}
                            {/*    leftPadding='2' rightPadding='2'*/}
                            {/*>*/}
                            {/*    <CardlessWithdrawalIcon */}
                            {/*        className='icon-component' */}
                            {/*        style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}}  */}
                            {/*    />*/}
                            {/*    <AppText */}
                            {/*        textSize='1.6' fontWeight='600' color='#25282B' //#ADADAD*/}
                            {/*        cursor='pointer' hoverColor='#0D968F' textWrap='normal'*/}
                            {/*        // cursor='pointer' hoverColor='#ADADAD' textWrap='normal'*/}
                            {/*        onClick={() => setIsCardlessWithdrawal(true)}*/}
                            {/*    >*/}
                            {/*        Cardless Withdrawal*/}
                            {/*    </AppText>*/}
                            {/*</FlexRow>*/}
                        </FlexRow>
                        <FlexRow 
                            gap='0.5' className='header-quick-links' 
                            onClick={() => setIsQuicklinks(true)}
                        >
                            <AppText 
                                textSize='1.7' fontWeight='600' color='#25282B' 
                                cursor='pointer' hoverColor='#0D968F'
                            >
                                Quick links
                            </AppText>
                            <AppSpan textSize='2' color='#0D968F' cursor='pointer'><HiOutlineChevronDoubleRight /></AppSpan>
                        </FlexRow>
                        <FlexRow width='auto' sizeUnit='' gap='5'>
                            <GridContainer width='auto' sizeUnit=''>
                                { (notifications?.length > 0) &&
                                    <AbsoluteContainer top='1' right='0.2'>
                                        <Circle size='1' bgColor='#FF0000' borderColor='#ffffff' />
                                    </AbsoluteContainer>
                                }
                                <AppSpan 
                                    color='#0D968F' textSize='2.5'
                                    onClick={handleNotification}
                                >
                                    <BsBellFill />
                                </AppSpan>
                            </GridContainer>
                            <></>
                        </FlexRow>
                    </FlexRow>
                </GridContainer>
            </FixedContainer>
            { isQuicklinks &&
                <QuickLinks 
                    close={() => setIsQuicklinks(false)}
                    isTransfer={() => setIsTransfer(true)}
                    isAirtime_Data={() => setIsAirtime_Data(true)}
                    isBillsPayment={() => setIsBillsPayment(true)}
                    isCardlessWithdrawal={() => setIsCardlessWithdrawal(true)}
                />
            }
            { isNotifPop &&
                <NotificationPopD2 
                    close={() => setIsNotifPop(false)} 
                />
            }
            { isTransfer &&
                <MakeTransferD2 
                    close={() => setIsTransfer(false)} 
                />
            }
            { isAirtime_Data &&
                <Airtime_DataD2 
                    close={() => setIsAirtime_Data(false)} 
                />
            }
            { isBillsPayment &&
                <BillTypesD2 
                    close={() => setIsBillsPayment(false)} 
                />
            }
            { isCardlessWithdrawal &&
                <CardlessWithdrawalD2 
                    close={() => setIsCardlessWithdrawal(false)} 
                />
            }
             {isAlert && (
                <AlertModal
                    title={"Verify your Account"}
                    body={
                        "To ensure secure transactions, please complete the verification process before performing any transaction. This helps us protect your account and maintain a safe platform for everyone"
                    }
                    close={() => setIsAlert(false)}
                    next={() => {
                        setIsAlert(false)
                        setVerifyAccount(true);
                    }}
                />
            )}
            {verifyAccount && (
                <AccountUpgradeD2 close={() => setVerifyAccount(false)} verifyMe={true} />
            )}
        </>
    )
}